import Vue from 'vue'
import Vuex from 'vuex'

import Global from './modules/global'
import Auth from './modules/auth'

import Client from './modules/client'
import ServiceRequest from './modules/servicerequest'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Global,
    Auth,
    Client,
    ServiceRequest
  }
})
